import styles from './JobMailTinyForm.less';
import React, { Component, PropTypes } from 'react';
import { EmailField, Button, MailIcon } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';

const states = Object.freeze({
  SAVING: 'SAVING',
  SAVED: 'SAVED',
  ERROR: 'ERROR',
  UNSAVED: 'UNSAVED'
});

export default class JobMailTinyForm extends Component {
  static propTypes = {
    prompt: PropTypes.string.isRequired,
    submissionHandler: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    status: PropTypes.oneOf(Object.keys(states))
  }

  static defaultProps = {
    errorMessage: '',
    status: states.UNSAVED
  }

  constructor() {
    super();
    this.handleEmailValue = this.handleEmailValue.bind(this);
    this.handleEmailFieldFocused = this.handleEmailFieldFocused.bind(this);
  }

  state = {
    emailAddress: '',
    emailAddressFocused: false
  }

  renderSuccess() {
    return (
      <div
        className={styles.message}>
        <p className={styles.thankYou}>Alert created</p>
        <p className={styles.createdMessage}>
          { 'We\'ll send new jobs to ' }
          <span data-hj-masked={true}>{ this.state.emailAddress }</span>
        </p>
      </div>
    );
  }

  handleEmailFieldFocused() {
    // Shows the privacy statement on field focus
    this.setState({
      emailAddressFocused: true
    });
  }

  handleEmailValue(e) {
    this.setState({
      emailAddress: e.target.value
    });
  }

  renderForm() {
    const { status, errorMessage } = this.props;
    const { emailAddress } = this.state;
    const inputProps = {
      required: true,
      onFocus: this.handleEmailFieldFocused,
      onChange: this.handleEmailValue,
      readOnly: status === states.SAVING,
      placeholder: 'Enter email',
      title: 'Please enter your email',
      'data-hj-masked': true,
      'data-automation': 'jobmail-email-tiny'
    };

    return (
      <form
        className={styles.form}
        onSubmit={this.props.submissionHandler(emailAddress)}>
        { this.state.emailAddressFocused &&
          <p className={styles.privacy}>
            You can cancel emails at <br />
            any time. By clicking <br />
            "Create alert" you agree to <br />
            <ExternalLink
              className={styles.privacyLink}
              analytics="jobmail:privacy"
              href="/privacy">
              {'SEEK\'s Privacy ​Statement'}
            </ExternalLink>
          </p> }
        <div className={styles.inputField}>
          <EmailField
            className={styles.email}
            inputProps={inputProps}
            invalid={status === states.ERROR}
            errorMessage={errorMessage}
          />
          <Button
            color="blue"
            type="submit"
            className={styles.button}>
            {status === states.SAVING ? 'Saving' : 'Create Alert'}
          </Button>
        </div>
      </form>
    );
  }

  render() {
    const { status, prompt } = this.props;
    return (
      <section className={styles.root}>
        <h1 className={styles.savePrompt}><MailIcon className={styles.icon} /> {prompt}</h1>
        { status !== states.SAVED && this.renderForm() }
        { status === states.SAVED && this.renderSuccess() }
      </section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanelTiny/components/JobMailTinyForm/JobMailTinyForm.js
 **/